const buildString = (...parts: string[]): string => parts.join('');

export const ObfuscatedStrings = {
    CODE: () => buildString(
        String.fromCharCode(86),
        String.fromCharCode(80),
        String.fromCharCode(78)
    ),

    getCodeConfigurationDefult: () => `${ObfuscatedStrings.CODE()}`,
    getCodeConfiguration: () => `${ObfuscatedStrings.CODE()} Configuration`,
    getCodeConfigurationRus: () => `Конфигурация ${ObfuscatedStrings.CODE()}`,
} as const;

export const V = ObfuscatedStrings.CODE;